export const galleryItems = [
  {
    id: 1,
    category: 'courts',
    src: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20six%20beautiful%20green%20tennis%20courts%20arranged%20in%20a%20row%2C%20surrounded%20by%20palm%20trees%20and%20tropical%20vegetation%2C%20blue%20sky%2C%20bright%20African%20sunlight%2C%20premium%20sports%20complex%2C%20drone%20photography%20perspective%2C%20luxury%20facility&width=800&height=600&seq=gallery-courts-01&orientation=landscape',
    alt: 'Vue aérienne des 6 courts du TCD',
    altEn: 'Aerial view of TCD 6 courts',
    title: 'Complexe complet — 6 courts',
    titleEn: 'Full complex — 6 courts',
  },
  {
    id: 2,
    category: 'courts',
    src: 'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20pristine%20tennis%20court%20surface%20with%20white%20lines%20and%20net%2C%20freshly%20maintained%20green%20clay%20texture%2C%20sunlight%20creating%20soft%20shadows%20across%20the%20court%2C%20professional%20sports%20surface%2C%20no%20people%20in%20frame%2C%20clean%20minimalist%20composition&width=800&height=600&seq=gallery-courts-02&orientation=landscape',
    alt: 'Surface du court central',
    altEn: 'Center court surface',
    title: 'Court Central — Surface ITF',
    titleEn: 'Center Court — ITF Surface',
  },
  {
    id: 3,
    category: 'tournaments',
    src: 'https://readdy.ai/api/search-image?query=Exciting%20tennis%20tournament%20match%20with%20two%20young%20players%20in%20intense%20rally%2C%20crowd%20of%20spectators%20cheering%20from%20bleachers%2C%20umpire%20chair%2C%20tournament%20banners%2C%20green%20court%2C%20golden%20afternoon%20sunlight%2C%20competitive%20sports%20atmosphere&width=800&height=600&seq=gallery-tournaments-01&orientation=landscape',
    alt: 'Match de tournoi ITF J30',
    altEn: 'ITF J30 tournament match',
    title: 'ITF J30 — Match intense',
    titleEn: 'ITF J30 — Intense Match',
  },
  {
    id: 4,
    category: 'tournaments',
    src: 'https://readdy.ai/api/search-image?query=Junior%20tennis%20players%20receiving%20medals%20and%20trophies%20on%20a%20podium%20ceremony%2C%20proud%20young%20athletes%20waving%20to%20crowd%2C%20flags%20in%20background%2C%20tennis%20court%20setting%2C%20celebration%20moment%2C%20prestigious%20award%20ceremony%20photography&width=800&height=600&seq=gallery-tournaments-02&orientation=landscape',
    alt: 'Cérémonie de remise des prix ITF',
    altEn: 'ITF award ceremony',
    title: 'Remise des prix — Champions ITF',
    titleEn: 'Awards Ceremony — ITF Champions',
  },
  {
    id: 5,
    category: 'coaching',
    src: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20coach%20demonstrating%20serve%20technique%20to%20group%20of%20attentive%20adult%20students%2C%20coach%20in%20mid-swing%20pose%2C%20tennis%20court%20background%2C%20rackets%20and%20balls%2C%20educational%20training%20session%2C%20bright%20natural%20daylight%2C%20sports%20instruction&width=800&height=600&seq=gallery-coaching-01&orientation=landscape',
    alt: 'Séance de coaching adulte',
    altEn: 'Adult coaching session',
    title: 'Formation — Coaching adulte',
    titleEn: 'Training — Adult Coaching',
  },
  {
    id: 6,
    category: 'coaching',
    src: 'https://readdy.ai/api/search-image?query=Intensive%20tennis%20coach%20certification%20workshop%2C%20group%20of%20coaches%20practicing%20drills%20on%20court%2C%20lead%20instructor%20guiding%20the%20session%2C%20clipboards%20and%20training%20cones%2C%20professional%20development%20atmosphere%2C%20green%20court%2C%20afternoon%20sunlight&width=800&height=600&seq=gallery-coaching-02&orientation=landscape',
    alt: 'Formation coaching international',
    altEn: 'International coach training',
    title: 'Formation Coach — Niveau International',
    titleEn: 'Coach Training — International Level',
  },
  {
    id: 7,
    category: 'kids',
    src: 'https://readdy.ai/api/search-image?query=Group%20of%20happy%20children%20aged%205-10%20years%20old%20holding%20tennis%20rackets%20on%20a%20court%2C%20smiling%20and%20posing%20for%20photo%2C%20colorful%20sportswear%2C%20coach%20kneeling%20beside%20them%2C%20bright%20sunny%20day%2C%20green%20court%2C%20playful%20and%20joyful%20mood%2C%20youth%20sports%20photography&width=800&height=600&seq=gallery-kids-01&orientation=landscape',
    alt: 'Enfants au Kid Summer Camp',
    altEn: 'Kids at Summer Camp',
    title: 'Kid Summer Camp — Nos champions',
    titleEn: 'Kid Summer Camp — Our Champions',
  },
  {
    id: 8,
    category: 'kids',
    src: 'https://readdy.ai/api/search-image?query=Young%20tennis%20players%20aged%2010-16%20practicing%20forehand%20drills%20with%20coach%20feeding%20balls%2C%20line%20of%20kids%20waiting%20their%20turn%2C%20tennis%20court%20with%20colorful%20training%20cones%2C%20sunny%20afternoon%2C%20green%20surface%2C%20active%20learning%20environment%2C%20sports%20education&width=800&height=600&seq=gallery-kids-02&orientation=landscape',
    alt: 'Entraînement jeunes',
    altEn: 'Youth training',
    title: 'Entraînement Jeunes — Discipline & Fun',
    titleEn: 'Youth Training — Discipline & Fun',
  },
  {
    id: 9,
    category: 'events',
    src: 'https://readdy.ai/api/search-image?query=Elegant%20tennis%20club%20evening%20event%20with%20players%20and%20guests%20socializing%20on%20terrace%20overlooking%20courts%2C%20string%20lights%2C%20tropical%20atmosphere%2C%20Douala%20city%20skyline%20in%20distance%2C%20premium%20club%20experience%2C%20warm%20golden%20evening%20light%2C%20luxury%20lifestyle%20photography&width=800&height=600&seq=gallery-events-01&orientation=landscape',
    alt: 'Soirée club TCD',
    altEn: 'TCD club evening',
    title: 'Soirée Membres — Sunset au TCD',
    titleEn: 'Members Night — Sunset at TCD',
  },
  {
    id: 10,
    category: 'events',
    src: 'https://readdy.ai/api/search-image?query=Opening%20ceremony%20of%20international%20tennis%20tournament%20with%20players%20marching%20with%20their%20country%20flags%2C%20colorful%20parade%20on%20green%20tennis%20court%2C%20spectators%20applauding%2C%20festive%20atmosphere%2C%20African%20and%20international%20flags%2C%20bright%20sunlight%2C%20celebration&width=800&height=600&seq=gallery-events-02&orientation=landscape',
    alt: 'Cérémonie d\'ouverture ITF',
    altEn: 'ITF opening ceremony',
    title: 'Cérémonie d\'Ouverture — Tournoi ITF',
    titleEn: 'Opening Ceremony — ITF Tournament',
  },
];

export const galleryCategories = [
  { id: 'all', key: 'gallery.all' },
  { id: 'courts', key: 'gallery.courts' },
  { id: 'tournaments', key: 'gallery.tournaments' },
  { id: 'coaching', key: 'gallery.coaching' },
  { id: 'kids', key: 'gallery.kids' },
  { id: 'events', key: 'gallery.events' },
];